export default {
  "menu.dashboard": "Dashboard",
  "menu.form": "Form",
  "menu.dashboard.workplace": "Workplace",
  "navbar.logout": "Logout",
  "settings.title": "Settings",
  "settings.themeColor": "Theme Color",
  "settings.content": "Content Setting",
  "settings.navbar": "Navbar",
  "settings.menuWidth": "Menu Width (px)",
  "settings.navbar.theme.toLight": "Click to use light mode",
  "settings.navbar.theme.toDark": "Click to use dark mode",
  "settings.menu": "Menu",
  "settings.footer": "Footer",
  "settings.popUpMenu": "Popup menu",
  "settings.popUpMenuType": "Popup menu type",
  "settings.popUpMenuType.button": "Grouped buttons",
  "settings.popUpMenuType.menu": "Grouped menu",
  "settings.tableHeightControl": "Table height control",
  "settings.formShowTab": "Form tab mode",
  "settings.tableSize": "Table size",
  "settings.otherSettings": "Other Settings",
  "settings.colorWeek": "Color Week",
  "settings.copySettings": "Copy Settings",
  "settings.copySettings.message": "Copy succeeded, please paste to file public/settings.json.",
  "settings.close": "Close",
  "settings.color.tooltip": "10 gradient colors generated according to the theme color",
  "title": "OpXMOM",
  "main": "OpXMOM",
  "maindata": "Base data",
  "marketing": "Marketing",
  "boms": "BOM info.",
  "flow": "Flow",
  "report": "Report",
  "theme": "Theme",
  "language": "Language",
  "logout": "Exit",
  "version": "Version",
  "feedback": "Feedback",
  "refresh": "Refresh",
  "b_refresh": "Refresh",
  "b_closeOther": "Close others",
  "b_close_all": "Close all",
  "b_close_current": "Close current",
  "b_Fill_out_the_action_plan": "Fill Out The Action Plan",
  "b_query": "Query",
  "b_complexQuery": "More",
  "b_add": "Add",
  "b_del": "Del",
  "b_output": "Output",
  "b_inport": "Import",
  "b_edit": "Edit",
  "b_show": "Show",
  "b_confirm": "Confirm",
  "b_cancel": "Cancel",
  "b_return": "Return",
  "b_save": "Save",
  "b_enable": "Enable",
  "b_disable": "Disable",
  "b_addChild": "Add child",
  "t_menu": "Menus",
  "t_page_is_loading": "Page is loading",
  "t_unauth_page": "Unauthorized page",
  "t_remind": "Prompt Info.",
  "t_form_change_content": "Content has been changed,Are you still want to exit?",
  "t_page": "page",
  "t_hasDelete": "Data has been delete",
  "t_deleteFail": "Fail to delete",
  "t_hasEnable": "Data has been enable",
  "t_enableFail": "Fail to enable",
  "t_hasDisabled": "Data has been disEnable",
  "t_disabledFail": "Fail to disable",
  "t_successToSet": "Failed to set",
  "t_confirmDeleteData": "Are you confirm to delete data？",
  "t_titleDeleteData": "Delete data",
  "t_keyword": "Keyword",
  "t_pleaseInput": "Please input",
  "t_pleaseSelect": "Please select",
  "t_failToAdd": "Fail to add",
  "t_successToAdd": "Success to add",
  "t_failToUpdate": "Fail to update",
  "t_successToUpdate": "Success to update",
  "t_formError": "Form exists error",
  "t_errorToReadData": "Error to read data",
  "t_operate": "Operate",
  "t_search": "Search",
  "t_titleAddData": "Add data",
  "t_titleEditData": "Edit data",
  "t_titleAdd": "Add",
  "t_titleEdit": "Edit",
  "t_titleShowData": "View data",
  "t_yes": "Yes",
  "t_no": "No",
  "t_grant_auth": "Grant auth",
  "t_plsSelectData": "Please select data",
  "t_searchUser": "Find user",
  "t_required": "Required",
  "t_ruleError": "Validate error",
  "t_ruleEmail": "Email error",
  "t_ruleMobile": "Mobile error",
  "t_ruleId": "Mobile No. error",
  "t_ruleUrl": "Url error",
  "t_ruleIpv4": "Ipv4 error",
  "t_ruleDate": "Date error",
  "t_ruleDateTime": "DateTime error",
  "t_ruleInt": "Integer error",
  "t_ruleFloat": "Float error",
  "t_rulePostalNo": "Postal No error",
  "t_ruleQQ": "QQ error",
  "t_ruleWechat": "Wechat error",
  "t_ruleCarNo": "Car No error",
  "t_ruleLetter": "String only letters",
  "t_ruleCN": "String must contain Chinese",
  "t_rulePassword": "Password strength verification error",
  "t_download": "Download",
  "t_downloadFail": "Download fail",
  "t_uploadFileSuccess": "Upload succeeded",
  "t_uploadFileFail": "Upload failed",
  "t_errParentNotItself": "Parent classification cannot be set to itself",
  "t_failToGetData": "Failed to get data",
  "t_formInitUrlDataError": "Sorry, the current page data is invalid. Please close this page.",
  "login.msg.userOrPwdError": "Error for user name or password",
  "login.msg.technicalSupport": "Loong-in",
  "common.no": "No.",
  "common.status": "Status",
  "common.lastModifierId": "Update user",
  "common.lastModificationTime": "Update time",
  "common.remark": "Remark",
  "common.success": "success",
  "common.fail": "fail",
  "common.sort":"Sort",
  "attachments.formTitle": "Attachments",
  "attachments.type": "Attachments type",
  "attachments.download": "Attachments download",
  "attachments.desc": "Description",
  "attachments.isDefault": "Is default",
  "attachments.format": "Format",
  "attachments.size": "Size(kb)",
  "attachments.downloadNum": "Download number",
  "attachments.uploader": "Uploader",
  "attachments.uploaded": "Uploaded",
  "attachments.upload": "Upload file",
  "workshop.workshop": "Workshop",
  "mold.formTitle": "Mold Information",
  "team.empList": "Emp List",
  "plants.reception_time": "Reception Time",
  "plants.planQty": "Planned quantity",
  "plants.Handling_situation": "Handling Situation",
  "plants.processedBy": "Processed By",
  "plants.isTheActionEffective": "Is The Action Effective",
  "plantsDelayHandling.processStatus": "Process Status",
  "plantsDelayHandling.pmcNo": "Pmc No",
  "plantsDelayHandling.planQty": "Plan Qty",
  "plantsDelayHandling.planEndDate": "Plan End Date",
  "plantsDelayHandling.actualFinishQty": "Actual Finish Qty",
  "plantsEfficiencyDefectiveHandling.effiRate": "Effi Rate",
  "plantsEfficiencyDefectiveHandling.pmcNo": "Pmc No",
  "plantsEfficiencyDefectiveHandling.nodeTitle": "Node Title",
  "plantsEfficiencyDefectiveHandling.materialCode": "Material Code",
  "plantsEfficiencyDefectiveHandling.workerName": "Worker Name",
  "plantsInspection.pmcNo": "Pmc No",
  "plantsInspection.workerName": "Worker Name",
  "plantsInspection.currentVerificationQuantity": "Current Verification Quantity",
  "productionScheduling.deliveryStatus": "Delivery Status",
  "productionScheduling.workOrderNumber": "Work Order Number",
  "productionScheduling.materialCode": "Material Code",
  "productionScheduling.materialName": "Material Name",
  "pickerDate.placeholder": "Please select date",
  "pickerMonth.placeholder": "Please select month",
  "pickerYear.placeholder": "Please select year",
  "pickerWeek.placeholder": "Please select week",
  "pickerQuarter.placeholder": "Please select quarter",
  "pickerRangeStart.placeholder": "Start date",
  "pickerRangeEnd.placeholder": "End date",
  "pickerTime.placeholder": "Please select time",
  'user.password': 'Password',
  'user.confirmPassword': 'Password again',
  'user.twicePwdNotSame': 'The passwords entered twice are inconsistent',
  'user.currentPassword': 'Current Password',
  'user.newPassword': 'New Password',
  'user.editPassword': 'Edit Password',
  "process.formTitle": "Process Information",
  "process.deptKey": "Department",
  "process.code": "Process code",
  "process.name": "Process name",
  "process.isOutput": "Is process",
  "process.description": "Process Description",
  "process.graph": "Graphical",
  "process.nodeTypeKey": "Node Type Key",
}
